const colors = {
  //Colores para corporativos
  BLUE_COLOR: "#004990",
  ORANGE_COLOR: "#EA5B13",
  GREEN_COLOR: "#00A447",
  GREEN_4_COLOR: "#03651D",
  //Colores secundario(para tela vinil)
  GREEN_2_COLOR: "#00a447",
  RED_COLOR: "#C00000",
  RED_ALERT: "#E82E19",
  //grises
  GRAY_1_COLOR: "#333333",
  GRAY_2_COLOR: "#4F4F4F",
  GRAY_3_COLOR: "#828282",
  GRAY_4_COLOR: "#BDBDBD",
  GRAY_5_COLOR: "#E0E0E0",
  GRAY_6_COLOR: "#F5F8FF",

  WHITE_COLOR: "#FFFFFF",
  SHADOW_COLOR: "#D0D0D0",
  YELLOW_COLOR: "#F8C100",
  GREEN_3_COLOR: "#86C724",
  GREEN_5_COLOR: "#DEF8B8",
  BLACK_COLOR: "#000000",
};

const styleScreenDashboard = {
  principalContainer: {
    overflow: "hidden",
    height: window.innerHeight,
    width: window.innerWidth,
  },
  insideContainer: {
    height: window.innerHeight - 50,
    padding: 15,
    marginTop: 10,
    backgroundColor: colors.GRAY_6_COLOR,
    borderRadius: 10,
    overflow: "auto",
    overflowStyle: "none",
    scrollBarWidth: "none",
  },
  titleColumn: {
    backgroundColor: colors.BLUE_COLOR,
    color: colors.WHITE_COLOR,
    textAlign: "center",
    marginBottom: 10,
  },
  containerColumn: {
    height: window.innerHeight - 140,
    padding: 15,
    marginTop: 10,
    backgroundColor: colors.GRAY_6_COLOR,
    borderRadius: 10,
    overflow: "auto",
    overflowStyle: "none",
    scrollBarWidth: "none",
  },
  containerColumnText: {
    height: window.innerHeight - 190,
    padding: 15,
  },
  containerColumnActive: {
    padding: 15,
    marginTop: 10,
    backgroundColor: colors.GREEN_5_COLOR,
    borderRadius: 10,
  },
  cardColumnDelivery: {
    marginTop: 5,
    //marginBottom: 5,
    borderRadius: 10,
    border: 0,
    width: "100%",
    backgroundColor: colors.WHITE_COLOR,
  },
  textCardDelivery: {
    color: colors.GRAY_2_COLOR,
    alignSelf: "flex-start",
    textAlign: "start",
  },
  cardColumn: {
    marginTop: 5,
    marginBottom: 10,
    borderRadius: 10,
    border: 0,
    width: "100%",
    backgroundColor: colors.WHITE_COLOR,
  },
  cardColumnSelected: {
    marginTop: 10,
    marginBottom: 10,
    borderRadius: 10,
    border: "solid 1",
    borderColor: colors.ORANGE_COLOR,
  },
  buttonAssignment: {
    backgroundColor: colors.ORANGE_COLOR,
    color: colors.WHITE_COLOR,
    borderRadius: 10,
    padding: 15,
    textAlign: "center",
  },
  borderCards: { borderRadius: 15, backgroundColor:colors.WHITE_COLOR },
  btnContainer: {
    //marginBottom: 5,
    borderRadius: 10,
    border: 0,
    width: "100%",
    backgroundColor: colors.WHITE_COLOR,
  },
  simpleInsideCard: {
    borderWidth: 1.5,
    borderColor: colors.RED_ALERT,
    borderRadius: 15,
    padding: 5,
  },
  textCenteredCard: {
    color: colors.GRAY_2_COLOR,
    alignSelf: "center",
    textAlign: "center",
  },
};

export { colors, styleScreenDashboard };
